import { useTranslation } from 'react-i18next'
import { isAppLocale, type AppLocale } from '@/constants/appLocale'
import travelVisionGif from '@/assets/gif/about-us.gif'
import { preFixImgUrl } from '@/utils'

const SLOGAN_IMAGE_BY_LOCALE: Record<AppLocale, string> = {
  zh_CN: 'e5334ac2ae3251074bd7cb07c4744bdb.png',
  zh_TW: '73773974a90fcac778cb66e1601fa55b.png',
  en_US: 'f1c3535d9790680ab1acd30d0657dc4a.png',
  ja_JP: '9a45382293fe0c99f0d29188c1a24314.png',
  ko_KR: 'f1c3535d9790680ab1acd30d0657dc4a.png',
}

const TravelVision = () => {
  const { i18n } = useTranslation()
  const locale = isAppLocale(i18n.language) ? i18n.language : 'zh_CN'
  const sloganImage = SLOGAN_IMAGE_BY_LOCALE[locale]

  return (
    <section className="w-full bg-white pt-[65px]">
      <div className="flex flex-col items-center mx-auto">
        {sloganImage ? (
          <img
            key={locale}
            src={preFixImgUrl(sloganImage)}
            alt=""
            className="h-[120px] w-auto object-contain"
            draggable={false}
          />
        ) : (
          <div className="h-[100px] w-[800px]" aria-hidden />
        )}

        <div
          className="mt-[48px] w-full flex justify-center pb-[85px]"
          style={{
            background: 'linear-gradient(180deg, #ffffff3d 0%, #ddf3ff3d 86.99%, #ffd8c33d 133.83%)',
          }}
        >
          <div className="w-[1200px] overflow-hidden rounded-[36px]">
            {travelVisionGif ? (
              <img
                src={travelVisionGif}
                alt=""
                className="block w-full"
                draggable={false}
              />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TravelVision
